import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import TopBar from '../components/layout/TopBar.svelte';
import Card from '../components/shared/Card.svelte';
import Button from '../components/shared/Button.svelte';
import { showToast } from '../components/shared/Toast.svelte';

import {
	getActiveChildren,
	getArchivedChildren,
	getActiveChildId,
	setActiveChild,
	archiveChild,
	restoreChild
} from '../lib/stores/children.svelte.ts';

import { getActiveTimer } from '../lib/stores/session.svelte.ts';
import { navigate } from '../lib/router.svelte.ts';

var root_4 = $.from_html(`<span class="badge svelte-3mvydddgkbxka">active</span>`);
var root_5 = $.from_html(`<button class="svelte-3mvydddgkbxka">Set active</button>`);
var root_3 = $.from_html(`<div class="row svelte-3mvydddgkbxka"><div class="info svelte-3mvydddgkbxka"><div class="name svelte-3mvydddgkbxka"> <!></div> <div class="age svelte-3mvydddgkbxka"> </div></div> <div class="actions svelte-3mvydddgkbxka"><button class="svelte-3mvydddgkbxka">Edit</button> <!> <button class="svelte-3mvydddgkbxka">Archive</button></div></div>`);
var root_2 = $.from_html(`<li><!></li>`);
var root_9 = $.from_html(`<div class="row svelte-3mvydddgkbxka"><div class="info svelte-3mvydddgkbxka"><div class="name svelte-3mvydddgkbxka"> <span class="badge archived svelte-3mvydddgkbxka">archived</span></div> <div class="age svelte-3mvydddgkbxka"> </div></div> <div class="actions svelte-3mvydddgkbxka"><button class="svelte-3mvydddgkbxka">Restore</button></div></div>`);
var root_8 = $.from_html(`<li><!></li>`);
var root_7 = $.from_html(`<ul class="list svelte-3mvydddgkbxka"></ul>`);
var root_6 = $.from_html(`<button class="archived-toggle svelte-3mvydddgkbxka"> </button> <!>`, 1);
var root = $.from_html(`<!> <div class="children-page svelte-3mvydddgkbxka"><!> <ul class="list svelte-3mvydddgkbxka"></ul> <!></div>`, 1);

function Children($$anchor, $$props) {
	$.push($$props, true);

	const activeList = $.derived(getActiveChildren);
	const archivedList = $.derived(getArchivedChildren);
	const activeId = $.derived(getActiveChildId);
	let showArchived = $.state(false);

	function ageLabel(dob) {
		const ms = Date.now() - dob;
		const days = Math.floor(ms / (24 * 60 * 60 * 1000));

		if (days < 30) return `${days} day${days === 1 ? '' : 's'}`;

		const months = Math.floor(days / 30);

		if (months < 24) return `${months} month${months === 1 ? '' : 's'}`;

		const years = Math.floor(months / 12);

		return `${years} year${years === 1 ? '' : 's'}`;
	}

	async function handleSetActive(id) {
		await setActiveChild(id);
		showToast('Active child switched', 'success');
	}

	async function handleArchive(id) {
		if (getActiveTimer()?.childId === id) {
			showToast('End the active session for this child first.', 'error');

			return;
		}

		const result = await archiveChild(id);

		if (!result.ok) showToast(result.error ?? 'Could not archive', 'error'); else showToast('Child archived', 'success');
	}

	async function handleRestore(id) {
		await restoreChild(id);
		showToast('Child restored', 'success');
	}

	var fragment = root();
	var node = $.first_child(fragment);

	TopBar(node, {
		title: 'Manage children',
		showBack: true,
		backPath: '/more/settings'
	});

	var div = $.sibling(node, 2);
	var node_1 = $.child(div);

	Button(node_1, {
		variant: 'primary',
		fullWidth: true,
		onclick: () => navigate('/profile/new'),
		children: ($$anchor, $$slotProps) => {
			$.next();

			var text = $.text('+ Add child');

			$.append($$anchor, text);
		},
		$$slots: { default: true }
	});

	var ul = $.sibling(node_1, 2);

	$.each(ul, 21, () => $.get(activeList), (child) => child.id, ($$anchor, child) => {
		var li = root_2();
		var node_2 = $.child(li);

		Card(node_2, {
			children: ($$anchor, $$slotProps) => {
				var div_1 = root_3();
				var div_2 = $.child(div_1);
				var div_3 = $.child(div_2);
				var text_1 = $.child(div_3);
				var node_3 = $.sibling(text_1);

				{
					var consequent = ($$anchor) => {
						var span = root_4();

						$.append($$anchor, span);
					};

					$.if(node_3, ($$render) => {
						if ($.get(activeId) === $.get(child).id) $$render(consequent);
					});
				}

				$.reset(div_3);

				var div_4 = $.sibling(div_3, 2);
				var text_2 = $.child(div_4);

				$.reset(div_4);
				$.reset(div_2);

				var div_5 = $.sibling(div_2, 2);
				var button = $.child(div_5);
				var node_4 = $.sibling(button, 2);

				{
					var consequent_1 = ($$anchor) => {
						var button_1 = root_5();

						$.delegated('click', button_1, () => handleSetActive($.get(child).id));
						$.append($$anchor, button_1);
					};

					$.if(node_4, ($$render) => {
						if ($.get(activeId) !== $.get(child).id) $$render(consequent_1);
					});
				}

				var button_2 = $.sibling(node_4, 2);

				$.reset(div_5);
				$.reset(div_1);

				$.template_effect(
					($0) => {
						$.set_text(text_1, `${$.get(child).name ?? ''} `);
						$.set_text(text_2, `${$0 ?? ''} old`);
					},
					[() => ageLabel($.get(child).dateOfBirth)]
				);

				$.delegated('click', button, () => navigate(`/profile/${$.get(child).id}`));
				$.delegated('click', button_2, () => handleArchive($.get(child).id));
				$.append($$anchor, div_1);
			},
			$$slots: { default: true }
		});

		$.reset(li);
		$.append($$anchor, li);
	});

	$.reset(ul);

	var node_5 = $.sibling(ul, 2);

	{
		var consequent_3 = ($$anchor) => {
			var fragment_1 = root_6();
			var button_3 = $.first_child(fragment_1);
			var text_3 = $.child(button_3);

			$.reset(button_3);

			var node_6 = $.sibling(button_3, 2);

			{
				var consequent_2 = ($$anchor) => {
					var ul_1 = root_7();

					$.each(ul_1, 21, () => $.get(archivedList), (child) => child.id, ($$anchor, child) => {
						var li_1 = root_8();
						var node_7 = $.child(li_1);

						Card(node_7, {
							children: ($$anchor, $$slotProps) => {
								var div_6 = root_9();
								var div_7 = $.child(div_6);
								var div_8 = $.child(div_7);
								var text_4 = $.child(div_8);

								$.next();
								$.reset(div_8);

								var div_9 = $.sibling(div_8, 2);
								var text_5 = $.child(div_9);

								$.reset(div_9);
								$.reset(div_7);

								var div_10 = $.sibling(div_7, 2);
								var button_4 = $.child(div_10);

								$.reset(div_10);
								$.reset(div_6);

								$.template_effect(
									($0) => {
										$.set_text(text_4, `${$.get(child).name ?? ''} `);
										$.set_text(text_5, `${$0 ?? ''} old`);
									},
									[() => ageLabel($.get(child).dateOfBirth)]
								);

								$.delegated('click', button_4, () => handleRestore($.get(child).id));
								$.append($$anchor, div_6);
							},
							$$slots: { default: true }
						});

						$.reset(li_1);
						$.append($$anchor, li_1);
					});

					$.reset(ul_1);
					$.append($$anchor, ul_1);
				};

				$.if(node_6, ($$render) => {
					if ($.get(showArchived)) $$render(consequent_2);
				});
			}

			$.template_effect(() => $.set_text(text_3, `${$.get(showArchived) ? 'Hide' : 'Show'} archived (${$.get(archivedList).length ?? ''})`));
			$.delegated('click', button_3, () => $.set(showArchived, !$.get(showArchived)));
			$.append($$anchor, fragment_1);
		};

		$.if(node_5, ($$render) => {
			if ($.get(archivedList).length > 0) $$render(consequent_3);
		});
	}

	$.reset(div);
	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	Children = $.hmr(Children);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-3mvydddgkbxka');
		Children[$.HMR].update(module.default);
	});
}

export default Children;

$.delegate(['click']);
import "bun-svelte:Children.svelte-2yar1d8l7c4li-style.css";